module.exports = __webpack_public_path__ + "img/light.c2952399.png";